module.exports = __webpack_public_path__ + "img/block-quote.d51e290f.svg";